export var alerts = {
  methods: {
    getAlertsData(generalExApplicationEx) {
      return {
        enabled: generalExApplicationEx && generalExApplicationEx.alertsTran != null,
        transactionName: generalExApplicationEx ? generalExApplicationEx.alertsTran : null,
        interval: generalExApplicationEx ? generalExApplicationEx.alertsInterval : null
      }
    },
    alertsEnabled(generalExApplicationEx) {
      return this.getAlertsData(generalExApplicationEx).enabled;
    },
    alertsIntervalEnabled(generalExApplicationEx) {
      return this.getAlertsData(generalExApplicationEx).enabled && this.getAlertsData(generalExApplicationEx).interval > 0;
    }
  }
}